var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _path11, _g2, _path12, _g3, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 262,
    viewBox: "0 0 264 262",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_120_7683)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M233.12 225.704C227.837 231.256 222.837 234.836 218.887 237.666C172.455 270.919 117.515 261.226 105.838 258.859C88.5955 255.363 55.2664 248.606 31.1702 220.322C-5.2854 177.529 0.390861 110.112 28.669 65.6085C33.8419 57.4678 61.1639 12.2869 116.697 5.04164C150.304 0.656879 189.48 9.50031 217.85 33.2253C277.401 83.0241 273.162 183.628 233.12 225.704Z",
    fill: "url(#paint0_linear_120_7683)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6754 1.85131C16.2498 0.541308 17.7806 -0.534763 18.8859 0.288665C30.1147 8.6474 57.7366 34.3608 57.3288 84.8202C56.8179 148.129 72.4443 169.435 90.2484 181.493C90.2484 181.493 67.2265 177.485 50.5783 155.955C9.7017 103.093 24.235 25.1412 16.6754 1.85131Z",
    fill: "#47BECC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6181 20.4786C28.6786 27.2859 30.6041 34.1306 32.2766 41.0353C33.9846 47.9306 35.4826 54.8736 36.7613 61.854C38.0128 68.8382 39.1331 75.8448 39.9543 82.8888C40.8064 89.9292 41.3548 96.9975 41.8807 104.096C42.446 111.188 42.9747 118.336 44.2384 125.451C45.4927 132.552 47.617 139.618 50.9712 146.088C51.8093 147.7 52.6802 149.303 53.6364 150.839C54.5644 152.394 55.5628 153.908 56.5865 155.403C58.6508 158.384 60.9166 161.233 63.384 163.902C68.3328 169.227 74.0906 173.796 80.2843 177.513C80.9358 177.904 81.7824 177.694 82.1742 177.043C82.5595 176.404 82.3626 175.579 81.7383 175.178L81.7336 175.176C80.2534 174.229 78.7853 173.267 77.3651 172.242C76.647 171.741 75.9524 171.209 75.2483 170.691C74.5649 170.146 73.859 169.629 73.1934 169.063C70.4917 166.85 67.9484 164.449 65.5954 161.872C60.8697 156.747 56.8874 150.891 53.672 144.716C52.0989 141.61 50.7575 138.394 49.6691 135.085C48.5826 131.775 47.7501 128.377 47.1108 124.929C45.8312 118.029 45.249 110.958 44.6331 103.871C44.0078 96.7833 43.33 89.6644 42.3607 82.5847C41.8854 79.044 41.3464 75.5126 40.7445 71.9924C40.4539 70.2305 40.1286 68.4751 39.8071 66.7188C39.4687 64.9652 39.1199 63.2145 38.7581 61.4666C37.2947 54.4777 35.6186 47.5366 33.7259 40.6582C31.7994 33.7891 29.6911 26.9734 27.3231 20.2493C27.2556 20.0575 27.0447 19.9564 26.8515 20.0238C26.6622 20.0893 26.5619 20.2914 26.6181 20.4786Z",
    fill: "#7ED5DF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.689 223.75C69.2484 226.248 66.3939 227.485 64.2462 226.129C52.393 218.645 20.7982 194.463 15.0788 146.475C10.2481 105.951 3.77124 84.4348 0.152687 74.8709C-0.612272 72.8488 1.65355 71.027 3.4722 72.2004C23.5402 85.1469 85.665 133.21 69.689 223.75Z",
    fill: "#4C94D3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3033 224.361C66.2574 224.404 66.2067 224.443 66.1524 224.479C65.6902 224.773 65.0762 224.636 64.7828 224.174C64.45 223.651 31.3524 171.192 22.0866 115.149C21.9975 114.61 22.3631 114.1 22.9041 114.01C23.445 113.922 23.9559 114.286 24.0449 114.826C33.2432 170.461 66.1271 222.591 66.458 223.111C66.7158 223.518 66.6408 224.042 66.3033 224.361Z",
    fill: "#91B3FA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7597 5.23674C57.3513 5.79255 52.4381 11.1505 52.4194 17.5704C52.3078 56.8358 52.1241 192.272 54.688 240.209C54.9599 245.287 59.1306 249.277 64.2256 249.332C89.4252 249.602 161.91 250.1 203.06 247.473C211.631 246.925 218.3 239.84 218.29 231.267C218.24 190.056 217.58 74.1596 211.925 21.1841C211.247 14.8372 206.135 9.88256 199.759 9.38663C172.276 7.2504 99.2928 2.15263 63.7597 5.23674Z",
    fill: "#30ECAC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5343 27.8617C62.0393 61.4491 60.6303 173.183 63.0902 214.422C63.4492 220.449 68.1402 225.208 73.9327 225.41C97.7805 226.24 158.933 227.844 193.78 224.017C200.054 223.329 204.85 217.9 205.017 211.326C205.889 177.05 208.243 72.9837 205.853 32.2053C205.471 25.7002 200.492 20.5098 194.251 20.0896C168.43 18.3529 102.124 14.3481 72.4919 16.8109C66.929 17.2731 62.6205 22.0462 62.5343 27.8617Z",
    fill: "#B7EAF0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M120.153 11.0761C120.173 12.0044 120.915 12.7539 121.844 12.7819C126.433 12.9214 139.359 13.3162 145.137 13.524C146.276 13.5651 147.147 12.5246 146.906 11.412C146.886 11.3774 146.738 9.9514 145.279 9.84941C141.371 9.57805 129.58 8.84726 121.788 9.29546C120.188 9.3881 120.101 11.2043 120.153 11.0761Z",
    fill: "#41B6C3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M101.449 103.05C118.723 103.05 132.726 89.0724 132.726 71.8305C132.726 54.5886 118.723 40.6113 101.449 40.6113C84.1751 40.6113 70.1719 54.5886 70.1719 71.8305C70.1719 89.0724 84.1751 103.05 101.449 103.05Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_120_7683",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 44,
    width: 57,
    height: 56
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M101.449 99.6331C116.833 99.6331 129.304 87.1853 129.304 71.8302C129.304 56.4751 116.833 44.0273 101.449 44.0273C86.0656 44.0273 73.5947 56.4751 73.5947 71.8302C73.5947 87.1853 86.0656 99.6331 101.449 99.6331Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_120_7683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.57 76.9128C108.311 76.9128 113.776 71.4579 113.776 64.7289C113.776 57.9999 108.311 52.5449 101.57 52.5449C94.8283 52.5449 89.3633 57.9999 89.3633 64.7289C89.3633 71.4579 94.8283 76.9128 101.57 76.9128Z",
    fill: "#41B6C3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_120_7683",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 44,
    width: 57,
    height: 56
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M101.449 99.6331C116.833 99.6331 129.304 87.1853 129.304 71.8302C129.304 56.4751 116.833 44.0273 101.449 44.0273C86.0656 44.0273 73.5947 56.4751 73.5947 71.8302C73.5947 87.1853 86.0656 99.6331 101.449 99.6331Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_120_7683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.0287 101.317H121.919C124.303 101.317 125.731 98.2412 124.448 95.8944C121.145 89.8563 114.234 80.9866 102.264 81.3871C90.728 81.7726 83.8903 89.7852 80.4526 95.5314C78.993 97.9708 80.4817 101.317 83.0287 101.317Z",
    fill: "#41B6C3"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M172.477 210H79.5234C76.4862 210 74 208.939 74 207.642V196.358C74 195.061 76.4862 194 79.5234 194H172.477C175.514 194 178 195.061 178 196.358V207.642C178 208.939 175.514 210 172.477 210Z",
    fill: "#41B6C3"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.876 137.683H90.1102C89.4127 137.683 88.8428 137.113 88.8428 136.418V130.327C88.8428 129.63 89.4137 129.062 90.1102 129.062H177.876C178.574 129.062 179.144 129.631 179.144 130.327V136.418C179.144 137.113 178.574 137.683 177.876 137.683Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2591 138.572C80.1511 138.572 82.4957 136.232 82.4957 133.345C82.4957 130.458 80.1511 128.118 77.2591 128.118C74.367 128.118 72.0225 130.458 72.0225 133.345C72.0225 136.232 74.367 138.572 77.2591 138.572Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.876 153.861H90.1102C89.4127 153.861 88.8428 153.291 88.8428 152.596V146.504C88.8428 145.808 89.4137 145.239 90.1102 145.239H177.876C178.574 145.239 179.144 145.809 179.144 146.504V152.596C179.144 153.292 178.574 153.861 177.876 153.861Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4309 150.364C82.8942 147.514 80.9555 144.829 78.1008 144.367C75.246 143.905 72.5561 145.84 72.0928 148.689C71.6295 151.539 73.5682 154.224 76.4229 154.686C79.2777 155.148 81.9676 153.213 82.4309 150.364Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.876 170.041H90.1102C89.4127 170.041 88.8428 169.471 88.8428 168.776V162.684C88.8428 161.988 89.4137 161.419 90.1102 161.419H177.876C178.574 161.419 179.144 161.989 179.144 162.684V168.776C179.144 169.472 178.574 170.041 177.876 170.041Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2591 170.93C80.1511 170.93 82.4957 168.59 82.4957 165.703C82.4957 162.817 80.1511 160.477 77.2591 160.477C74.367 160.477 72.0225 162.817 72.0225 165.703C72.0225 168.59 74.367 170.93 77.2591 170.93Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M177.876 186.22H90.1102C89.4127 186.22 88.8428 185.65 88.8428 184.955V178.864C88.8428 178.168 89.4137 177.599 90.1102 177.599H177.876C178.574 177.599 179.144 178.168 179.144 178.864V184.955C179.144 185.65 178.574 186.22 177.876 186.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M77.2591 187.11C80.1511 187.11 82.4957 184.77 82.4957 181.883C82.4957 178.996 80.1511 176.656 77.2591 176.656C74.367 176.656 72.0225 178.996 72.0225 181.883C72.0225 184.77 74.367 187.11 77.2591 187.11Z",
    fill: "white"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M142.194 120.832H73.3525C72.7338 120.832 72.2275 120.326 72.2275 119.709V113.333C72.2275 112.715 72.7338 112.21 73.3525 112.21H142.194C142.813 112.21 143.319 112.715 143.319 113.333V119.709C143.319 120.326 142.813 120.832 142.194 120.832Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M305.155 261.014H2.96765C2.43353 261.014 2 260.606 2 260.104C2 259.601 2.43353 259.193 2.96765 259.193H305.155C305.689 259.193 306.122 259.601 306.122 260.104C306.122 260.606 305.689 261.014 305.155 261.014Z",
    fill: "#41B6C3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M221.677 33.9C221.492 31.048 219.766 28.5206 217.179 27.2948L183.665 11.4064C181.518 10.3893 179.028 10.3893 176.882 11.4064L143.367 27.2948C140.781 28.5215 139.055 31.048 138.869 33.9C135.726 82.4037 166.883 100.076 177.096 104.54C179.122 105.425 181.424 105.425 183.449 104.54C193.663 100.076 224.82 82.4037 221.677 33.9Z",
    fill: "#4C94D3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M170.135 18.1017C169.956 18.1017 169.785 18.0016 169.704 17.8294C169.59 17.5918 169.692 17.3073 169.93 17.195L177.848 13.4409C178.086 13.3277 178.371 13.4288 178.484 13.6665C178.597 13.9041 178.496 14.1886 178.258 14.3009L170.339 18.055C170.274 18.0868 170.204 18.1017 170.135 18.1017Z",
    fill: "#91B3FA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M141.432 44.2806C141.176 44.2806 140.964 44.0776 140.956 43.8202C140.85 40.665 140.905 37.3769 141.121 34.0448C141.253 32.0134 142.484 30.2056 144.334 29.3279L166.88 18.6402C167.118 18.5269 167.403 18.628 167.515 18.8657C167.629 19.1033 167.528 19.3878 167.289 19.5001L144.744 30.1878C143.205 30.9167 142.183 32.4186 142.073 34.1056C141.859 37.4059 141.804 40.6641 141.909 43.7875C141.918 44.0504 141.711 44.2713 141.449 44.2797C141.443 44.2806 141.437 44.2806 141.432 44.2806Z",
    fill: "#91B3FA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M213.573 35.7927C213.536 35.0694 213.104 34.4237 212.449 34.1131L181.118 19.2605C180.583 19.0069 179.962 19.0069 179.427 19.2605L148.097 34.1131C147.441 34.4237 147.01 35.0694 146.973 35.7927C146.046 53.8857 150.233 68.9825 159.426 80.6827C166.434 89.6038 174.633 94.3843 179.437 96.6141C179.967 96.8602 180.575 96.8602 181.105 96.6141C185.91 94.3834 194.109 89.6028 201.117 80.6827C210.312 68.9825 214.499 53.8857 213.573 35.7927Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M160.377 55.6243C162.968 54.0224 166.371 54.8589 167.92 57.4789L175.203 69.8013C175.933 71.0346 177.759 70.912 178.315 69.5917L194.699 30.6987C195.517 28.7581 198.396 29.3382 198.415 31.4426C198.523 43.2167 195.935 65.6626 177.548 84.842C177.548 84.842 167.068 81.0636 158.264 62.9397C156.992 60.3216 157.9 57.157 160.377 55.6243Z",
    fill: "#30ECAC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M227.157 250.137C227.157 250.137 227.757 253.527 228.051 256.883C228.166 258.195 227.153 259.334 225.835 259.388C221.358 259.574 211.78 259.936 208.343 259.783C207.826 259.76 207.489 259.232 207.68 258.753C207.84 258.351 208.15 258.026 208.544 257.845L224.364 250.588L227.157 250.137Z",
    fill: "#4C94D3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M227.648 248.145L227.166 252.2C227.166 252.2 224.395 253.487 222.502 252.038L223.649 247.519L227.648 248.145Z",
    fill: "url(#paint1_linear_120_7683)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M227.286 171.904C227.494 172.963 228.403 224.751 222.857 247.959C222.766 248.338 222.959 248.728 223.32 248.875C224.171 249.222 225.838 249.725 227.837 249.791C228.456 249.812 229.011 249.41 229.185 248.817C230.77 243.433 238.367 216.454 239.358 190.682C240.465 161.885 239.358 189.701 239.358 189.701L238.709 171.9L227.286 171.904Z",
    fill: "url(#paint2_linear_120_7683)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M245.355 251.904C245.355 251.904 246.311 253.616 247.235 258.164C247.402 258.986 246.827 259.772 245.991 259.854C244.513 259.999 242.236 260.185 240.413 260.173C239.572 260.168 238.917 259.437 239.018 258.604C239.22 256.944 239.85 254.22 241.793 252.097L245.355 251.904Z",
    fill: "#4C94D3"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M246.194 246.689L245.068 252.821C245.068 252.821 243.954 253.649 241.751 253.049L242.289 246.45L246.194 246.689Z",
    fill: "url(#paint3_linear_120_7683)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M249.237 173.493C253.773 200.817 248.253 241.026 246.392 248.896C246.277 249.378 245.888 249.746 245.399 249.828C244.568 249.965 243.2 250.077 241.852 249.686C241.387 249.552 241.061 249.133 241.042 248.651C240.792 242.288 241.241 203.228 237.015 187.791C236.802 187.008 236.323 186.326 235.661 185.857L227.457 180.036L226.828 170.626L249.237 173.493Z",
    fill: "url(#paint4_linear_120_7683)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M220.334 121.72C233.927 121.495 248.926 125.282 248.926 125.282C252.978 148.881 249.635 176.101 249.635 176.101C239.111 178.855 227.24 174.416 227.24 174.416C225.491 164.553 217.33 136.793 217.33 136.793C210.688 135.971 205.217 134.058 200.712 131.529C204.149 127.552 205.769 122.492 206.473 119.502C211.278 120.993 216.141 121.789 220.334 121.72Z",
    fill: "#4C94D3"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M180.182 101.734C181.517 100.125 183.207 100.886 183.207 100.886C185.207 109.32 195.695 116.158 206.471 119.501C205.767 122.491 204.148 127.552 200.711 131.528C182.828 121.492 180.182 101.734 180.182 101.734Z",
    fill: "url(#paint5_linear_120_7683)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M180.506 102.144C180.367 102.587 181.985 103.262 182.937 101.448C182.971 100.579 183.5 96.856 182.979 96.1486C180.208 92.3777 174.837 87.6514 174.837 87.6514C173.928 88.5459 174.676 89.4236 174.676 89.4236L177.282 92.1334C176.738 93.1169 176.072 93.9469 175.761 95.1361C175.525 96.0372 175.669 96.9992 176.125 97.8188C176.582 98.6413 177.207 99.7109 177.796 100.547C178.914 102.132 180.506 102.144 180.506 102.144Z",
    fill: "url(#paint6_linear_120_7683)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M178.423 93.8926L180.797 95.9025L181.543 97.9031L179.425 100.248C179.425 100.248 178.713 96.2777 178.184 95.4187C177.656 94.5588 177.931 94.1433 178.423 93.8926Z",
    fill: "url(#paint7_linear_120_7683)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M243.712 138.421L248.926 125.283C248.926 125.283 261.623 133.895 263.711 144.812C261.312 144.987 256.946 145.611 252.673 147.765C251.735 142.609 243.712 138.421 243.712 138.421Z",
    fill: "#4C94D3"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M232.617 150.782C232.617 150.782 246.871 158.824 251.682 151.958C252.68 150.532 252.919 149.115 252.673 147.764C256.946 145.61 261.312 144.987 263.711 144.811C264.341 148.101 264.008 151.603 262.07 155.141C253.645 170.525 230.73 154.29 230.73 154.29L232.617 150.782Z",
    fill: "url(#paint8_linear_120_7683)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M234.329 160.956L226.549 133.837C226.461 133.529 226.198 133.304 225.879 133.267C224.469 133.103 220.385 132.642 215.669 132.244C209.989 131.764 203.393 131.376 199.45 131.706C198.889 131.753 198.551 132.345 198.8 132.847C201.041 137.374 210.262 155.788 214.88 161.82C215.033 162.02 215.27 162.136 215.521 162.134L233.572 161.967C234.098 161.963 234.474 161.46 234.329 160.956Z",
    fill: "#BDD0FB"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M214.862 129.892L209.222 128.954C208.922 128.904 208.675 129.191 208.771 129.479L209.33 131.168C209.378 131.315 209.507 131.421 209.661 131.442L215.088 132.165C215.37 132.203 215.601 131.948 215.536 131.673L215.191 130.198C215.153 130.04 215.024 129.92 214.862 129.892Z",
    fill: "#7D97F4"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M219.086 134.659L218.621 132.243C218.574 132 218.373 131.817 218.128 131.792L206.735 130.639C206.351 130.599 206.044 130.95 206.134 131.325L206.859 134.335C206.917 134.575 207.127 134.749 207.374 134.762L218.507 135.322C218.871 135.34 219.154 135.014 219.086 134.659Z",
    fill: "#7D97F4"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M232.449 154.403C232.449 154.403 233.533 149.955 233.096 148.377C232.659 146.8 231.812 144.77 228.988 145.221C226.165 145.672 222.835 146.86 222.835 146.86C222.835 146.86 223.003 148.915 225.149 148.252L223.818 149.279C223.818 149.279 224.009 150.925 225.821 150.046L224.583 151.409C224.583 151.409 225.361 152.761 226.695 151.894C228.028 151.026 228.668 154.939 232.449 154.403Z",
    fill: "url(#paint9_linear_120_7683)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M234.103 110.704L238.429 123.189C238.5 123.396 238.416 123.625 238.224 123.731C237.044 124.381 232.797 126.262 227.678 123.023C227.145 122.685 226.782 122.135 226.701 121.51L225.301 110.704H234.103Z",
    fill: "url(#paint10_linear_120_7683)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M224.693 99.1426C224.693 99.1426 219.943 108.066 220.552 111.671C221.16 115.275 227.047 115.017 232.187 112.089L235.778 102.453L224.693 99.1426Z",
    fill: "url(#paint11_linear_120_7683)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M231.959 107.357C231.75 107.265 231.673 107.01 231.798 106.819C232.179 106.239 232.892 105.056 233.12 104.019C233.12 104.019 233.974 103.473 230.947 102.75C227.92 102.027 223.406 100.905 222.457 98.3325C221.532 95.8248 223.963 89.5199 227.84 94.5438C227.987 94.7346 228.277 94.7393 228.424 94.5475C229.06 93.7213 230.731 92.008 233.052 93.0466C235.223 94.0188 235.467 95.6067 235.437 96.4077C235.429 96.6435 235.64 96.826 235.871 96.782C236.969 96.5733 239.603 96.3937 240.833 99.0913C241.846 101.314 241.188 102.571 240.589 103.186C240.395 103.385 240.48 103.714 240.746 103.795C241.468 104.016 242.399 104.626 242.306 106.313C242.177 108.646 239.564 108.44 238.821 108.334C238.699 108.317 238.576 108.359 238.493 108.449C237.856 109.154 234.982 112.145 231.871 112.506C231.602 112.537 231.393 112.272 231.481 112.015L232.827 108.11C232.89 107.928 232.803 107.73 232.628 107.652L231.959 107.357Z",
    fill: "#395185"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M231.419 107.913C231.419 107.913 234.801 105.597 235.048 107.547C235.296 109.497 232.003 110.372 230.372 109.645L231.419 107.913Z",
    fill: "url(#paint12_linear_120_7683)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_120_7683",
    x1: 296.405,
    y1: 338.16,
    x2: 66.8871,
    y2: 52.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_120_7683",
    x1: 227.648,
    y1: 250.123,
    x2: 222.502,
    y2: 250.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_120_7683",
    x1: 239.85,
    y1: 210.847,
    x2: 222.835,
    y2: 210.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_120_7683",
    x1: 246.194,
    y1: 249.858,
    x2: 241.751,
    y2: 249.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_120_7683",
    x1: 250.983,
    y1: 210.291,
    x2: 226.826,
    y2: 210.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_120_7683",
    x1: 243.374,
    y1: 116.117,
    x2: 217.084,
    y2: 116.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_120_7683",
    x1: 192.84,
    y1: 74.7562,
    x2: 180.781,
    y2: 91.9243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_120_7683",
    x1: 180.308,
    y1: 98.3761,
    x2: 172.967,
    y2: 87.0671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_120_7683",
    x1: 264.001,
    y1: 153.288,
    x2: 230.73,
    y2: 153.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_120_7683",
    x1: 233.2,
    y1: 149.806,
    x2: 222.835,
    y2: 149.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_120_7683",
    x1: 228.205,
    y1: 105.98,
    x2: 233.7,
    y2: 126.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_120_7683",
    x1: 238.857,
    y1: 89.0622,
    x2: 222.781,
    y2: 114.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_120_7683",
    x1: 243.397,
    y1: 91.9092,
    x2: 227.322,
    y2: 117.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_120_7683"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 264,
    height: 262,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/Verified.80fb7dd4ba9a450c3b65d93ef5e360fa.svg";
export { ForwardRef as ReactComponent };